/**
 * @generated SignedSource<<1541ab7a9d02a3fa5cb63384339ed5a2>>
 * @relayHash 7880781d0e49b39cb7b2e933b00d5c08
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7880781d0e49b39cb7b2e933b00d5c08

import { ConcreteRequest } from 'relay-runtime';
export type setTodoNotDoneInput = {
  clientMutationId?: string | null | undefined;
  todoId: string;
};
export type TodoMutations_SetTodoNotDoneMutation$variables = {
  input: setTodoNotDoneInput;
};
export type TodoMutations_SetTodoNotDoneMutation$data = {
  readonly setTodoNotDone: {
    readonly todo: {
      readonly done: boolean;
      readonly doneTs: string | null | undefined;
    };
  } | null | undefined;
};
export type TodoMutations_SetTodoNotDoneMutation = {
  response: TodoMutations_SetTodoNotDoneMutation$data;
  variables: TodoMutations_SetTodoNotDoneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "doneTs",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoMutations_SetTodoNotDoneMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoNotDonePayload",
        "kind": "LinkedField",
        "name": "setTodoNotDone",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoMutations_SetTodoNotDoneMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoNotDonePayload",
        "kind": "LinkedField",
        "name": "setTodoNotDone",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7880781d0e49b39cb7b2e933b00d5c08",
    "metadata": {},
    "name": "TodoMutations_SetTodoNotDoneMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0b99c35e5c09f01383f398b48cb97eca";

export default node;
